<template>
  <div
    ref="container"
    class="size-full mh-i"
  >
    <div class="relative size-full mh-i">
      <div class="absolute size-full flex pointer-events-none justify-center items-end z-[1] print-hidden">
        <div
          class="bg-white rounded-t-lg px-4 pt-1"
          data-i18n="seeFullMap"
        >
          <fa
            class="mr-2"
            icon="search"
          />{{ $t('seeFullMap') }}
        </div>
      </div>
      <div
        class="cursor-zoom-in size-full block mh-i"
        role="button"
        @click="$emit('openMap')"
      >
        <MapboxPreview
          class="size-full mh-i"
          :center="center"
          :zoom="zoom"
          :markers="tripLocationMarkers"
          lazy
        />
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    trip: {
      type: Object,
      required: true,
    },

    activeItinerary: {
      type: Object,
      required: true,
    },
  },

  emits: ['openMap'],
  data () {
    return {
      tripLocations: null,
    }
  },
  computed: {
    zoom () {
      return this.activeItinerary?.overviewmap?.thumb_bounds?.zoom || 7
    },

    tripLocationMarkers () {
      if (!this.activeItinerary?.overviewmap) {
        return []
      }

      if (!this.activeItinerary.overviewmap.points?.length && this.activeItinerary.overviewmap.thumb_bounds) {
        const { lng_center: lng, lat_center: lat } = this.activeItinerary?.overviewmap.thumb_bounds ?? []
        return [[lng, lat]]
      }

      return this.activeItinerary?.overviewmap.points.map((p) => {
        return [
          parseFloat(p.lng),
          parseFloat(p.lat),
        ]
      })
    },

    center () {
      if (this.tripLocations?.length && this.tripLocations.length < 2) {
        const center = this.tripLocations[0]
        return [center.lng, center.lat]
      }

      if (!this.activeItinerary?.overviewmap?.thumb_bounds?.lat_center) {
        return false
      }

      return [
        parseFloat(this.activeItinerary?.overviewmap.thumb_bounds.lng_center),
        parseFloat(this.activeItinerary?.overviewmap.thumb_bounds.lat_center),
      ]
    },
  },
})
</script>
